module.exports = __webpack_public_path__ + "cn.f99eb7ba5683427d0269.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/cn.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/cn.svg
// module chunks = styles